import { ComponentPropsWithoutRef } from 'react'

import Navbar from '@/common/Navbar'
import { cn } from '@/theme/utils'

export default function MainLayout({
  className,
  children,
  ...rest
}: ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      {...rest}
      className={cn(
        'bg-background',
        'relative flex size-full flex-col overflow-hidden',
        className,
      )}
    >
      <div className='pointer-events-none absolute inset-0 z-0'>
        <div
          className={cn(
            'absolute -bottom-48 left-1/2 h-130 w-full -translate-x-1/2 rounded-full',
            'bg-primary/10 blur-3xl',
          )}
        />
      </div>
      <div className='relative isolate z-10 order-1 flex flex-1 flex-col overflow-x-hidden overflow-y-auto sm:order-2'>
        <Navbar />
        <div className='z-20 flex-1'>{children}</div>
        <div className='z-10 my-8 flex flex-col items-center justify-center'>
          <span className='text-foreground/60 mt-8 text-center text-sm'>
            All rights reserved © Bridgeless {new Date().getFullYear()}
          </span>
        </div>
      </div>
    </div>
  )
}
